<section class="nav-group collapsible">
    <input #sectionClicked id="{{sectionId}}" type="checkbox" [checked]="isChecked" (click)="onChange()">
    <label for="{{sectionId}}">{{ caption }}</label>
    <ng-content></ng-content>
</section>
